import { all, call, fork, put } from "typed-redux-saga";
import { takeLatestPerKey } from "@itk/typescript-utils";
import { Action, actions } from "./form-list-item-picture-autocomplete-store";
import { errorActions } from "src/components/error-viewer/error-store";
import { ListItemService, Shared_PictureResolutions } from "src/backend/openapi/v1";

export function* getListItemsRequest(action: ReturnType<typeof actions.getListItemsRequest>) {
  try {
    const result = yield* call(ListItemService.getApiV1ListItem, action.payload.listId, Shared_PictureResolutions.Small);
    yield put(actions.getListItemsSuccess(action.payload.listId, result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(actions.getListItemsFail(action.payload.listId));
  }
}

export function* watchGetListItemsRequest() {
  yield takeLatestPerKey(Action.GetListItemsRequest, getListItemsRequest, action => action.payload.listId);
}

export function* formListItemPictureAutocompleteSaga() {
  yield all([fork(watchGetListItemsRequest)]);
}
